import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "wouter";

import { Pagination } from "@nens/chakra/components";
import { FilterSet, useScenarios } from "@nens/ldo/api-v1";
import { ScenarioListItem } from "@nens/ldo/components";
import { useTableData } from "@nens/react/hooks";

interface ExcelImportScenariosProps {
  excelImportId: number;
}

export function ExcelImportScenarios({ excelImportId }: ExcelImportScenariosProps) {
  const { page, limit, offset, pageSize, nextPage, previousPage, setPage } = useTableData({
    initialPageSize: 10,
  });
  const setLocation = useLocation()[1];

  const scenariosResponse = useScenarios(
    {
      offset,
      limit,
    },
    new FilterSet({ excel_import_id: [excelImportId] })
  );

  const scenarios = scenariosResponse.isSuccess ? scenariosResponse.data.items : [];

  const numPages = scenariosResponse.isSuccess
    ? Math.ceil(scenariosResponse.data.total / pageSize)
    : 0;
  // We store it in a React state, so that we can continue showing the old number while loading
  // a new page; saves UI flickering.
  const [currentNumPages, setCurrentNumPages] = useState(numPages);
  useEffect(() => {
    if (numPages > 0 && numPages !== currentNumPages) {
      setCurrentNumPages(numPages);
    }
  }, [currentNumPages, numPages]);

  return (
    <>
      <Box h="100%" w="100%">
        {scenarios.map((scenario) => (
          <ScenarioListItem
            authMode="private"
            checkbox={false}
            key={scenario.id}
            scenario={scenario}
            onSelect={() => {
              setLocation(`/scenarios/${scenario.id}`);
            }}
          />
        ))}
        {scenariosResponse.isFetching ? (
          <Center h={`${60 * pageSize}px`}>
            <Spinner size="xl" />
          </Center>
        ) : scenarios.length === 0 ? (
          <Center h={`${60 * pageSize}px`}>
            <Text>
              <FormattedMessage id="table.empty" defaultMessage="There are 0 results." />
            </Text>
          </Center>
        ) : null}
      </Box>
      <Center>
        <Pagination
          m={4}
          toPage1={() => setPage(1)}
          toLastPage={() => setPage(currentNumPages)}
          toPrevious={previousPage}
          toNext={page < numPages ? nextPage : undefined}
          page={page}
          numPages={currentNumPages}
        />
      </Center>
    </>
  );
}
